module.exports = __webpack_public_path__ + "img/summa.logo.03e5f584.png";